import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import ConsentText from './consent-text'
import { useSetState } from '../hooks/use-set-state'

const PrivacyPolice = ({ partner, setAgreed: setAllAgreed }) => {
  const {
    t,
    i18n: { language }
  } = useTranslation()

  const {
    customPrivacyLink,
    customPrivacyLinkReference,
    custom_privacy_consent
  } = JSON.parse(partner.app_settings?.components || '{}')

  const partnerName = customPrivacyLinkReference
    ? 'Aivy\u00A0GmbH'
    : partner.name.replace(/ /g, '\u00A0')

  const aivyPrivacyConsent = {
    text: t('aivy_consent_text', { partnerName }),
    link: {
      href: customPrivacyLink || 'https://aivy.app/datenschutz/',
      label: t('aivy_consent_label')
    }
  }

  const [agreed, setAgreed] = useSetState(() => {
    const state = { aivy_policy: false }

    if (custom_privacy_consent) state.custom_privacy_consent = false

    return state
  })

  const handleAgreed = (key, value) => {
    const a = { ...agreed, [key]: value }

    setAgreed(a)
    setAllAgreed(Object.values(a).every(Boolean))
  }

  return (
    <div>
      <ConsentText
        consent={aivyPrivacyConsent}
        agreed={agreed.aivy_policy}
        setAgreed={(bool) => handleAgreed('aivy_policy', bool)}
      />
      {custom_privacy_consent && (
        <ConsentText
          className='mt-4'
          consent={custom_privacy_consent[language]}
          agreed={agreed.custom_privacy_consent}
          setAgreed={(bool) => handleAgreed('custom_privacy_consent', bool)}
        />
      )}
      {customPrivacyLinkReference && (
        <p className='mt-8 text-sm text-gray-700'>
          {t('datapolicy_additional')}
          <a
            href={customPrivacyLinkReference}
            className='ml-1 font-medium text-gray-900 underline'
            target='_blank'
            rel='noreferrer'
          >
            {`${partner.name} ${t('datapolicy_alt')}`}
          </a>
        </p>
      )}
    </div>
  )
}

PrivacyPolice.propTypes = {
  partner: PropTypes.object.isRequired,
  agreed: PropTypes.bool.isRequired,
  setAgreed: PropTypes.func.isRequired
}

export default PrivacyPolice
